import { apiClient } from './apiClient';
import type { MonthlyReport, DetailedMonthlyReport } from '../types/report';

export const reportService = {
  async getMonthlyReport(
    businessProfileId: string,
    year: number,
    month: number,
    authToken: string
  ): Promise<MonthlyReport> {
    return apiClient.get<MonthlyReport>(
      `/business-profile/${businessProfileId}/reports/monthly?year=${year}&month=${month}`,
      authToken
    );
  },

  async getMonthlyReportDetailed(
    businessProfileId: string,
    year: number,
    month: number,
    authToken: string
  ): Promise<DetailedMonthlyReport> {
    return apiClient.get<DetailedMonthlyReport>(
      `/business-profile/${businessProfileId}/reports/monthly/detailed?year=${year}&month=${month}`,
      authToken
    );
  },
};
